import { render } from "./BoxLinks.vue?vue&type=template&id=0653a29a"
import script from "./BoxLinks.vue?vue&type=script&lang=ts"
export * from "./BoxLinks.vue?vue&type=script&lang=ts"
script.render = render

export default script